import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/workspace/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Today, we’re incredibly excited to share proposed new branding for the Starswap Protocol.`}</p>
    <p>{`And, over the coming week, we’ll be hosting a community call to discuss the creative process and also soliciting feedback through the governance forum.`}</p>
    <h1 {...{
      "id": "visually-distinguishing-labs-from-protocol",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#visually-distinguishing-labs-from-protocol",
        "aria-label": "visually distinguishing labs from protocol permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Visually Distinguishing Labs from Protocol`}</h1>
    <p>{`Since its inception, the unicorn logo has been a steadfast marker of the spirit of Starswap. But as the Starswap ecosystem has grown, the need for a more robust graphic toolkit to express and distinguish the ecosystem’s many facets has become apparent.`}</p>
    <p>{`In particular, separate visual identities will clarify the distinction between the Starswap Protocol and Starswap Labs to the Starswap community and external observers, further defining the function, responsibilities, and governance of each. The two are sometimes confused with each other, but in practice they are entirely separate things: the Starswap Protocol is the set of on-chain, immutable smart contracts that facilitate peer-to-peer trading, while Starswap Labs refers to the software development studio that builds and maintains products generally adjacent to the Protocol. Starswap Labs is one of hundreds of companies that builds products on top of the Protocol and may someday build products further afield from the Protocol.`}</p>
    <h1 {...{
      "id": "designing-a-new-mark",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#designing-a-new-mark",
        "aria-label": "designing a new mark permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Designing a new mark`}</h1>
    <p>{`Graphic designer Timothy Luke, who worked with Starswap Grants to develop its logo system, drew the new Protocol mark. His ornate, futuristic sensibility felt like the perfect fit for depicting a crypto-powered unicorn.`}</p>
    <p>{`The final logo-set consists of 4 variations based on size:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/264ae5cffa0f1cdb76f961df440d8095/d9ed5/protocol.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACT0lEQVQ4y2VUSWsUYRCdS4xR0KRnepbe91m6++ueOEkcCTMuWRRlQiBGUUQQNIZRclKiCEKOnoIechTFg7/AH+Ehd0+e/B1PqqannZhD8S1d9erVq/q6UIkNVIXJVotNVGMTSmxCjS0+k1WEAfIjO3EnDPbP98JEgZ0Siw9ziYayMHAxUTHVrvBaEjqqWVIltSEJjf3GScegbARIG1kYsCIHA7fD6233Eg6qt3DTm8dyEKPvC0iJDk3YeGB1sav3sK+swg1djj0FSKwo2/e5e9gxevhx4RGOZ3awq/ex4qcjJlm575Q19vsi3cV1P8FsouUS5IBj2p+lLRyVNvFreohP8gZeqTewr6zACV0uXYstPLS6+CZt46O8wRXMZuWfYqhHNva0a/hQuYPjmWdA4QCH8gCbzgLiZp0BSTuS5X1tHUO9j1YryDQ288YyIF16oYsX+lU813v4ee4pfp95icfmFdYqCL08kKoRzTq80IPCTTGRT0o8UTIZCU7Z/0ztMcs3yiq27SWkzQakRGMfWegMTlXRKk8kImNAEpUCiOETcxmH5QE347W6wuzKmeBG4sJveaN5TS3UIx9e5J3odGFMlTJRcNgKWJ9uPcKWvYh+IFAUOoqJjqVGyN/KqYmzQRFf77/F0doQ0/Ui1MQeAY5fABllomAS+3I9xPm0xszHY0HdtCOH2ZYiDaKbIpoPeZ9raHYCaG0H9mIDSpaFtJF4HKx/M5atcvYMCaAYqihmYEyKNDQ6PtS2A3MhgJo6I+dMj8ln9f8Tm/wHTHb5LygEh/XeUJWpAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "protocol",
            "title": "protocol",
            "src": "/static/264ae5cffa0f1cdb76f961df440d8095/c1b63/protocol.png",
            "srcSet": ["/static/264ae5cffa0f1cdb76f961df440d8095/5a46d/protocol.png 300w", "/static/264ae5cffa0f1cdb76f961df440d8095/0a47e/protocol.png 600w", "/static/264ae5cffa0f1cdb76f961df440d8095/c1b63/protocol.png 1200w", "/static/264ae5cffa0f1cdb76f961df440d8095/d61c2/protocol.png 1800w", "/static/264ae5cffa0f1cdb76f961df440d8095/97a96/protocol.png 2400w", "/static/264ae5cffa0f1cdb76f961df440d8095/d9ed5/protocol.png 2880w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Luke also developed a mark for Starswap Labs, using the atomic parts of the glimmer and shield. Compared to the ornate unicorn logo, the mark for Labs is more neutral, representing an organization that has a connection to, but is separate from, the Protocol.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0dda73848d8120e6175befdca0606922/d9ed5/labs.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAABhklEQVQ4y8VTTUsCURQVXCWBpo4648yo+JUf7zmDWWZ+UZlpRaZBUFBtimoTUQtpEQT1E6pd/YV+R/Rfat/ixJtmBh0qCIQWh/s+7j333MN7tgANYZSwjZ6QhOCnMlhk4PX4F5j1jNDY+KgML5Xgzona2q+D06NvANa9STqoMEjCiGdioKkkRBI21cokAp6GIJEIBBLW8ow7lscwpJAljCk8jqUaPmx9vNnPccd14CcyduVZXAWWcO1r4pSv4Uis4DbQxpk4j5tAC31hEeUE0abirYSXQgMvjgM8enp4cm+CU0PopIpoZgrYUurYzi9gjZbQjKpYjeaxHFNRTVDNEtNPRijohCdSDa+OQ7zbL3DvXoerGMb0ShXlXgOt/S7ae12o7Tm4FBHOXFDDRE40/Rvy0Kd7+ODdwLNzBySVBKfIUGpTiM+kodQLyFZUTJaoNtog/FaFxgGTPq4IWme33tmbCYLLivCkg1/rjKh5ywqN+Os7FKydvyn4iWiI0Pq4rWP869f7BPPIfDGQNe54AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "labs",
            "title": "labs",
            "src": "/static/0dda73848d8120e6175befdca0606922/c1b63/labs.png",
            "srcSet": ["/static/0dda73848d8120e6175befdca0606922/5a46d/labs.png 300w", "/static/0dda73848d8120e6175befdca0606922/0a47e/labs.png 600w", "/static/0dda73848d8120e6175befdca0606922/c1b63/labs.png 1200w", "/static/0dda73848d8120e6175befdca0606922/d61c2/labs.png 1800w", "/static/0dda73848d8120e6175befdca0606922/97a96/labs.png 2400w", "/static/0dda73848d8120e6175befdca0606922/d9ed5/labs.png 2880w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`The final result is a cohesive system of marks that symbolizes the relationship between Starswap Protocol, Starswap Labs, and Starswap Grants Program. We’re blown away by the vision Luke has brought to life, and we hope you’re just as excited.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3c90fc0c9f8a82ba9a0877cf50305473/d9ed5/family.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB7ElEQVQ4y61Ty27TQBT1shGQqnHcxK8Zv5KW2jPjVIaUhlZqWUAXhEWhsAiVQJXaJaI7tvxAF2xBQuIPED/AB8CCDzroju3gpKwQizuvO+ece+feMfqS43+aMd+IhkmOnmDXz0Xj/G8+yWDQQBtbcDgNR08DGFwRzK0pZleYfmPWhLToKoZV5eJW7qAWILKe4miNbKzkfbRyuxQiMslh5gwd6cGSJbbGGR3lYWcjxUk4xqX7AMXmFizp64tJmuBqfYovayd43z+aZ2AqH4+SbZzyXcyCe3gejuGJAOsUIbE/TEb4ZD7Ft/YML8IdOCLAmvI0OYx3+Nk6x6+VCyRprIVM6eMVn+Ao2cadzS288Q7gZ2FJSM7xRoora4qP5jFeBrvgWYi2crE/lPh+8zU+WE/wo3WOQZqgK32dHkVH+xu5gzN2H3ElZhBrlEW4dA/x1jvEZJjplOvKfW3PdJSfO8+0CBWHsnocFzhje5jGBS78fR2dfkNdFOkjymKdkl1Vy67OgyzST0IiNYhmloU4GCgcR3d1dHUAhu4rwWCJshB1tXoNMEXW7DWa6S4VlKxbZaTbxlEBnDyEo0LdDqVjEWwvkf1pLX5NyBhOBG7v5eDFcPGHyEXgfL0ktuwzWDHQZLwYwB1Fi1/rH/7yb5MSfPezqVa6AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "family",
            "title": "family",
            "src": "/static/3c90fc0c9f8a82ba9a0877cf50305473/c1b63/family.png",
            "srcSet": ["/static/3c90fc0c9f8a82ba9a0877cf50305473/5a46d/family.png 300w", "/static/3c90fc0c9f8a82ba9a0877cf50305473/0a47e/family.png 600w", "/static/3c90fc0c9f8a82ba9a0877cf50305473/c1b63/family.png 1200w", "/static/3c90fc0c9f8a82ba9a0877cf50305473/d61c2/family.png 1800w", "/static/3c90fc0c9f8a82ba9a0877cf50305473/97a96/family.png 2400w", "/static/3c90fc0c9f8a82ba9a0877cf50305473/d9ed5/family.png 2880w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h1 {...{
      "id": "an-on-chain-brand",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#an-on-chain-brand",
        "aria-label": "an on chain brand permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`An on-chain brand`}</h1>
    <p>{`We are taking steps to be the first organization to bring their brand fully on chain.`}</p>
    <p>{`Once the community has settled on branding, the Protocol logos will be generated as NFTs and sent to the Starswap governance treasury. Community members may use the logos as they see fit under the rights set out by Starswap Labs’ `}<a parentName="p" {...{
        "href": "https://starswap.xyz/trademarks/"
      }}>{`Trademark Guidelines`}</a>{`.`}</p>
    <h1 {...{
      "id": "request-for-comment",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#request-for-comment",
        "aria-label": "request for comment permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Request for Comment`}</h1>
    <p>{`The Starswap community is invited to contribute comments and propose changes to the redesign before it goes live through a thread on the Governance forum.`}</p>
    <p>{`On Wednesday, November 10th at 1pm ET, the Labs design team will share a presentation, describing the inspiration for the new branding and providing additional context on the creative process, before opening up the floor to community discussion. (Details for the presentation call will be posted on the Starswap Labs Twitter account and in the governance forum thread.)`}</p>
    <p>{`We’re thrilled to share these updates and look forward to hearing your thoughts over the coming week.`}</p>
    <p>{`Details for community feedback can be found on the `}<a parentName="p" {...{
        "href": "https://gov.starswap.xyz/t/Starswap-protocol-brand-update-request-for-comment/14822"
      }}>{`forum post`}</a>{`.`}</p>
    <hr></hr>
    <p>{`To get involved and stay up to date:`}</p>
    <ul>
      <li parentName="ul">{`Join the Starswap community `}<a parentName="li" {...{
          "href": "https://discord.com/invite/FCfyBSbCU5"
        }}>{`discord`}</a></li>
      <li parentName="ul">{`Follow Starswap Labs on `}<a parentName="li" {...{
          "href": "/Starswap"
        }}>{`Twitter`}</a></li>
      <li parentName="ul">{`Subscribe to the Starswap Labs `}<a parentName="li" {...{
          "href": "https://starswap.xyz/rss.xml"
        }}>{`blog`}</a></li>
      <li parentName="ul">{`Register as a delegate on `}<a parentName="li" {...{
          "href": "https://sybil.org/#/delegates/Starswap"
        }}>{`Sybil`}</a></li>
      <li parentName="ul">{`Participate in Starswap `}<a parentName="li" {...{
          "href": "https://gov.starswap.xyz/"
        }}>{`governance`}</a></li>
    </ul>
    <p>{`Starswap Team
🦄`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      